import React from 'react';
import clsx from 'clsx';
import './style.css';

type Props = {
	children: string | JSX.Element | JSX.Element[];
	maxWidth?: number;
	absolute?: boolean;
	size?: 'small' | 'medium' | 'large' | 'full';
	className?: string;
};

export const Wrapper = ({
	children,
	size = 'large',
	maxWidth,
	className,
	absolute = false,
}: Props) => {
	const widthPresets = {
		small: 800,
		medium: 960,
		large: 1200,
		full: '100%',
	};

	return (
		<div
			style={
				maxWidth
					? { maxWidth }
					: size
					? { maxWidth: widthPresets[size] }
					: undefined
			}
			className={clsx('wrapper', className, { 'wrapper--absolute': absolute })}
		>
			{children}
		</div>
	);
};
